// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"AddNewContract_formContainer__2h0N1","form":"AddNewContract_form__2TfwA","formItem":"AddNewContract_formItem__2k6hi","error":"AddNewContract_error__36Lyp"};